import { render, staticRenderFns } from "./UiFormattedContent.vue?vue&type=template&id=52104ec4&"
import script from "./UiFormattedContent.vue?vue&type=script&lang=ts&"
export * from "./UiFormattedContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports